export const SHIPPING_GET_REQUEST = "SHIPPING_GET_REQUEST";
export const SHIPPING_GET_SUCCESS = "SHIPPING_GET_SUCCESS";
export const SHIPPING_GET_FAIL = "SHIPPING_GET_FAIL";

export const SHIPPING_ADD_STATE_REQUEST = "SHIPPING_ADD_STATE_REQUEST";
export const SHIPPING_ADD_STATE_SUCCESS = "SHIPPING_ADD_STATE_SUCCESS";
export const SHIPPING_ADD_STATE_FAIL = "SHIPPING_ADD_STATE_FAIL";

export const SHIPPING_UPDATE_STATE_REQUEST = "SHIPPING_UPDATE_STATE_REQUEST";
export const SHIPPING_UPDATE_STATE_SUCCESS = "SHIPPING_UPDATE_STATE_SUCCESS";
export const SHIPPING_UPDATE_STATE_FAIL = "SHIPPING_UPDATE_STATE_FAIL";

export const SHIPPING_UPDATE_FREE_REQUEST = "SHIPPING_UPDATE_FREE_REQUEST";
export const SHIPPING_UPDATE_FREE_SUCCESS = "SHIPPING_UPDATE_FREE_SUCCESS";
export const SHIPPING_UPDATE_FREE_FAIL = "SHIPPING_UPDATE_FREE_FAIL";

export const SHIPPING_DELETE_STATE_REQUEST = "SHIPPING_DELETE_STATE_REQUEST";
export const SHIPPING_DELETE_STATE_SUCCESS = "SHIPPING_DELETE_STATE_SUCCESS";
export const SHIPPING_DELETE_STATE_FAIL = "SHIPPING_DELETE_STATE_FAIL";
